import { useCallback, useMemo } from "react";
import { loadExportPrefs, saveExportPrefs } from "./exportPrefs";
import type { ExportPrefs, ExportSchema } from "./types";

/** Remembered dialog choices for one report, validated against its schema. */
export function useExportPrefs(schema: ExportSchema | undefined): {
  prefs: ExportPrefs | undefined;
  save: (prefs: ExportPrefs) => void;
} {
  const prefs = useMemo(() => (schema ? loadExportPrefs(schema) : undefined), [schema]);
  const save = useCallback(
    (next: ExportPrefs) => {
      if (schema) saveExportPrefs(schema.type, next);
    },
    [schema],
  );
  return { prefs, save };
}
